import * as React from 'react';

import { Utils } from '@/utils/app';

import './index.less';

const { jumpGameDetail, handleClickCouponRep} = Utils;

function GameCoupon(props: any) {
  const { couponData, gameBaseInfo, fromId, handTipsImgVis } = props;

  const getRep = (obj: any) => {
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: obj.gameId,
      area: obj?.area,
      coupon_id: obj.couponId,
      coupon_position: obj.position,
    };
    handleClickCouponRep(newObj);
    jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId,}, handTipsImgVis);
  };

  const couponObj: any = {
    0: '已领取',
    1: '已使用',
    2: '已过期',
    3: '可领取',
    4: '已抢光',
    5: '未开始',
  };

  return (
    <div className={`e-c-i-warp ${(couponData || []).length == 1 ? 'bg1' : ''}`}>
      <div className='c-i-w-title'>优惠券</div>
      {(couponData || []).map(({ price, type, range, title, term, explain, status, couponUuid, gameId }: any, index: number) => (
        <div
          className={`event-coupon-item-warp ${!index ? 'first-child' : ''} ${status == 1 || status == 2 || status == 4 ? 'greys' : ''} `}
          onClick={() => getRep({ couponId: couponUuid, gameId, position: index, area: 'inforcard' })}
          key={`${index}_H`}>
          <div className='coupon-item'>
            <div className={`c-item-left-r ${status == 1 || status == 2 || status == 4 ? 'greys' : ''  }`}>
              <div className={`left-r-upper`}>
								￥<span className={`${(price || '').length > 4 ? 'active' : ''} `}>{price}</span>
              </div>
              <div className='left-r-lower'>{type == 0 ? `满￥${range}可用` : '无门槛'}</div>
            </div>
            <div className='c-item-middle'>
              <div className={`title ${status == 1 || status == 2 || status == 4 ? 'greys' : ''}`}>{title}</div>
              <div className='term'>{term}</div>
              <div className='explain'>{explain}</div>
            </div>
            <div
              className={`c-item-right btn-bg${status}`}
              onClick={(event: any) => {
                event.stopPropagation();
                event.cancelBubble = true;
                getRep({ couponId: couponUuid, position: index, gameId, area: status == 3 ? 'receive' : 'detail' });
              }}>
              {couponObj[status]}
            </div>
            {status == 0 || status == 1 || status == 2 || status == 4 ? <span className={`watermark water${status}`}></span> : null}
          </div>
        </div>
      ))}
    </div>
  );
}

export default GameCoupon;
